import * as ERROR from "./../const/error.json";
import MobilePrefix from "./../const/mobile-prefix.json";

export function validateMobileNumber(text) {
    const prefixes = MobilePrefix.map((mobilePrefix) => {
        return mobilePrefix.prefix;
    });
    const prefixRegEx = new RegExp(`^(${prefixes.join("|")})[0-9]{7}$`);

    return !prefixRegEx.test(text) ? ERROR.InvalidMobileNumber : false;
}
